import { request } from "@/api/server/index";

export default {
  //V080_マニュアル画面
  Manual: {
    // 初期表示
    indexManual(params) {
      return request({
        url: "/manual/indexManual",
        data: params,
        method: "post"
      });
    },
    //マニュアル（b1）をクリックしたときの処理
    downloadManualFile(params) {
      return request({
        url: "/manual/downloadManualFile",
        data: params,
        method: "post",
        responseType: "blob"
      });
    }
  },
  //V200_担当者選択画面
  PICSelect: {
    // 初期表示
    indexPICSelect(params) {
      return request({
        url: "/pICSelect/indexPICSelect",
        data: params,
        method: "post"
      });
    },
    // 部署リスト取得
    searchDepartmentList(params) {
      return request({
        url: "/pICSelect/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    // 情報取得と画面表示
    searchPICSelectList(params) {
      return request({
        url: "/pICSelect/searchPICSelectList",
        data: params,
        method: "post"
      });
    }
  },
  //V201_団体選択画面
  OrgSelect: {
    // 保険会社データ取得
    indexOrgSelect(params) {
      return request({
        url: "/orgSelect/indexOrgSelect",
        data: params,
        method: "post"
      });
    },
    // 保険会社団体データ取得
    searchOrgSelectList(params) {
      return request({
        url: "/orgSelect/searchOrgSelectList",
        data: params,
        method: "post"
      });
    }
  },
  //V202_募集企画選択画面
  RecruitmentPlanSelect: {
    //初期表示
    indexRecruitmentPlanSelect(params) {
      return request({
        url: "/recruitmentPlanSelect/indexRecruitmentPlanSelect",
        data: params,
        method: "post"
      });
    },
    //検索（b2）をクリックしたときの処理
    searchRecruitmentPlanSelectList(params) {
      return request({
        url: "/recruitmentPlanSelect/searchRecruitmentPlanSelectList",
        data: params,
        method: "post"
      });
    }
  },
  //V203_団体第2階層選択画面
  OrgTwoSelect: {
    //V203_団体第2階層選択画面 初期表示
    indexParent2OrgSelect(params) {
      return request({
        url: "/parent2OrgSelect/indexParent2OrgSelect",
        data: params,
        method: "post"
      });
    },
    //V203_団体第2階層選択画面  団体第2階層の取得
    searchParent2OrgSelectList(params) {
      return request({
        url: "/parent2OrgSelect/searchParent2OrgSelectList",
        data: params,
        method: "post"
      });
    }
  },
  //V204_団体第3階層選択画面
  OrgThreeSelect: {
    //V204_団体第3階層選択画面 初期表示
    indexParent3OrgSelect(params) {
      return request({
        url: "/parent3OrgSelect/indexParent3OrgSelect",
        data: params,
        method: "post"
      });
    },
    //V204_団体第3階層選択画面 団体第3階層の取得
    searchParent3OrgSelectList(params) {
      return request({
        url: "/parent3OrgSelect/searchParent3OrgSelectList",
        data: params,
        method: "post"
      });
    },
    //V204_団体第3階層選択画面 マニュアル（b1）をクリックしたときの処理
    downloadManualFile(params) {
      return request({
        url: "/manual/downloadManualFile",
        data: params,
        method: "post"
      });
    }
  }
};
